export enum TQuestionnaireQuestionKind {
    MULTI_CHOICE = "multi_choice",
    OPEN_ENDED = "open_ended",
}

export type TQuestionnaireQuestionId = number;
export type TQuestionnaireOptionId = number;

export interface IQuestionnaireOption {
    id: TQuestionnaireOptionId;
    text: string;
}

interface IQuestionnaireQAndAPairBase {
    id: TQuestionnaireQuestionId;
    question: string;
}

export interface IMultiChoiceQAndAPair extends IQuestionnaireQAndAPairBase {
    kind: TQuestionnaireQuestionKind.MULTI_CHOICE;
    options: IQuestionnaireOption[];
    allow_multiple: boolean;
    include_other: boolean;
    selected_option_ids: TQuestionnaireOptionId[];
    other_text?: string;
}

export interface IFreeQAndAPair extends IQuestionnaireQAndAPairBase {
    kind: TQuestionnaireQuestionKind.OPEN_ENDED;
    answer_text?: string;
}

export type IQuestionnaireQAndAPair = IMultiChoiceQAndAPair | IFreeQAndAPair;

